import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

export const staffSessionGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    if (authService.getImpersonationInfo().isImpersonating) {
        return true;
    }

    return inject(Router).parseUrl('/v2');
};
